import {configureStore} from '@reduxjs/toolkit'
import snackbarReducer from '../store/slices/snackbar.slice'
import agentsReducer from '../store/slices/agents.slice'
import conversationsReducer from '../store/slices/conversations.slice'
import navReducer from '../store/slices/nav.slice'
import changesReducer from '../store/slices/changes.slice'
import layoutReducer from '../store/slices/layout.slice'

export const store = configureStore({
    reducer: {
        snackbar: snackbarReducer,
        agents: agentsReducer,
        conversations: conversationsReducer,
        nav: navReducer,
        changes: changesReducer,
        layout: layoutReducer,
    },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch